export default "By cancelling this booking, all holds will be released and the booking will not longer be processable.\n\nAre you sure you want to cancel?"